//src/api/order.js
import request from '@/utils/request'

export default {
    get(id) {
        return request.get('/trade/' + id)
    },
    page(page, size, { orderId, userId, phone, startDate, endDate }) {
        return request.get('/trade', { 
            params: { 
                "pageNo": page, 
                "pageSize": size, 
                "orderId": orderId, 
                "userId": userId,
                "phone": phone,
                "startDate": startDate, 
                "endDate": endDate 
            } 
        });
    },
    list({ orderId }) {
        return request.get('/trade', { 
            params: { 
                "orderId": orderId
            } 
        });
    }
}


